import React, {useState,useContext,useRef,useEffect} from "react";
import { useForm  } from 'react-hook-form';
import { useNavigate  } from "react-router-dom";
import Lang from '../../lang/translations';
import helpers from "../../_helpers/helpersFunction";
import Context from '../../context/context';
import { formatCreditCard, getCreditCardType } from 'cleave-zen'
import { isValidCreditCard } from '../utils';

import Module3ds_adyen from "./adyen/3ds_module";
import Module3ds_trpay from "./trustPay/3ds_module";
import Module3ds_maxpay from "./maxpay/3ds_module";
import Module3ds_shift4 from "./shift4/3ds_module";

import { GTMEvents } from '../../_helpers/gtm/gtm';

const config = require("../../_helpers/configServizi"); 

export default function CreditCardForm(props) {

   const domain = window.location.hostname;

  let navigate = useNavigate();
  const context = useContext(Context)

//4917610000000000 adyen
//4012001800000016 3ds
//4242424242424242 non 3ds
//4024007118468684 insufficient_funds

  //4012001800000016 shift4 3ds
  //4012000100000007 shift4 non 3ds

  const [number, setNumber] = useState(domain == "localhost" ? "4012001800000016" : "");
    const [expiry, setExpiry] = useState(domain == "localhost" ? "03/30" : "");
    const [cvc, setCvc] = useState(domain == "localhost" ? "737" : "");
    const [icon, setIcon] = useState("fas fa-credit-card");
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState({cardNumber:false,expiry:false,cvc:false,firstName:false,lastName:false});
    const [tentativi, setTentativi] = useState({});
    const [form_visibile, setform_visibile] = useState(false);
    const [load, setLoad] = useState(true);
    const { register, handleSubmit  } = useForm();

    const [module3ds, setModule_3ds] = useState();
    const [props_3ds, setProps_3ds] = useState();
  const [crossSellingAccepted, setCrossSellingAccepted] = useState(checkCrossSelling());

    
 

   

  const placeHolderNome = Lang( {"w": "nome","page": "creditCardForm","var":true} );
  const placeHolderCognome = Lang( {"w": "cognome","page": "creditCardForm","var":true} );
  const placeHolderNumeroCarta = Lang( {"w": "numero_carta","page": "creditCardForm","var":true} )

  


  function checkCrossSelling() {
    if (context.flusso.crossSelling && !context.flusso.crossSelling_accepted) {
      console.log("Cross selling attivo, accettato: ", !context.flusso.crossSelling_accepted)
      return true
    } else {
      console.log("Cross selling non attivo")
      return false
    }
  }
 

    function changeCreditCardIcon(issuer){

      if(issuer === "visa"){
        setIcon("fab fa-cc-visa");
      }
      else if(issuer === "mastercard"){
        setIcon("fab fa-cc-mastercard");
      }
      else if(issuer === "amex"){
        setIcon("fab fa-cc-amex");
      }
      else if(issuer === "diners"){
        setIcon("fab fa-cc-diners-club");
      }
      else if(issuer === "discover"){
        setIcon("fab fa-cc-discover");
      }
      else if(issuer === "jcb"){
        setIcon("fab fa-cc-jcb");
      }else{
        setIcon("fas fa-credit-card");
      }
    }




      function Spinner(){

        if(disabled){
          return (<div className="spinner-border text-light" role="status">
          <span className="sr-only"><Lang w={"caricando"} page={"signupForm"}/></span>
        </div>);
        }else{
          return (<div>{Lang( {"w": "continua","page": "creditCardForm"} )}</div>)
          
        }
      }

      function checkErorrs(data){
        var tmpObj = error
     
        data.firstName.length == 0 ? tmpObj.firstName=true : tmpObj.firstName= false
        data.lastName.length == 0 ? tmpObj.lastName=true : tmpObj.lastName= false

        if(!tmpObj.number){
          number.length == 0 ? tmpObj.cardNumber=true : tmpObj.cardNumber= false
        }

        number.length < 16  ? tmpObj.cardNumber=true : tmpObj.cardNumber= false

        if(!tmpObj.expiry){
          expiry.length == 0 ? tmpObj.expiry=true : tmpObj.expiry= false
        }
   
        cvc.length < 3 ? tmpObj.cvc=true : tmpObj.cvc= false
        
        setError({...error})

       

        const campi = Object.values(tmpObj).map(el => el == true)

        helpers.logToBackend("Errori su compilazione",{clickid:localStorage.getItem('trackerId'),campi:error})
        
        return(campi.some(el => el === true))
      
        
      }
   

    const onSubmit = async (data) => {
     

  
        if(checkErorrs(data)) return 
        
        data.cardMonth = expiry.substring(0, 2)
        data.cardYear = expiry.substring(3, 5)
        data.cardSecurityCode = cvc
        data.cardNumber = number.replace(/\s+/g, '');
        
        return await sendToBackend(data)
    
      
    }



    async function sendToBackend(data){

        //ReactGA.event({ category: 'User',action: 'Tentativo'})
    
        
          
        
        try{
          setDisabled(true)

          
          const d = new Date();

          data.country = helpers.getCountry()
          data.rateplan = context.rateplanScelto
          data.descriptor = config.servizi[domain].descriptor
          data.payment_company = config.servizi[domain].payment_company
          data.city = localStorage.getItem("city")
          data.clickid = localStorage.getItem("trackerId")
          data.domain = window.location.hostname
          data.paySource = "CREDITCARD"
          data.email = context.email
          data.newCard = context.newCard
          data.actonfile = false
          
          data.language= navigator.language
          data.screenHeight= window.screen.height
          data.screenWidth= window.screen.width
          data.timezone= d.getTimezoneOffset()
          data.userAgent= navigator.userAgent
          data.javaEnabled= true
          data.javascriptEnabled= true
          data.screenColorDepth= window.screen.colorDepth
          data.crossSelling = crossSellingAccepted
          data.pacchettone = context.flusso.rateplans?.pacchettone?.id

    
          const response = await helpers.tryCharge(data)
          helpers.logToBackend("Tentativo Pagamento",{pixel:true,clickid:localStorage.getItem('trackerId'),et:"tentativo"})
          helpers.kpiPanel(context,"tentativo")
          GTMEvents.add_payment_info(localStorage.getItem("trackerId"),context.email,window.location.hostname)


          if(response.status === "ok") {

            if(response.threeDS){
              //---- PROCEDURA PER 3DS
              console.log("procedura 3DS",response,response.threeDS)
              procedura3DS(response)
              return
            }else{
              context.setPageOkEnabled(true)
              context.setPremiumLevel(data.rateplan.premiumLevel)
              const credMsg = context.creditiMessaggi + data.rateplan.crediti
              context.setCreditiMessaggi(credMsg)
              context.setCustomerId(response.data.customerId)
              context.setValoreMessaggio(context.flusso.valoreMessaggio)
              context.setActonfile(true)
              context.setNewCard(false)
              //ReactGA.pageview('/ok', 'Charge OK');
              navigate('/ok/')
            }
          }else{
            
            const contenuto = helpers.contenuto_popop_pagamento(response.message)
            
            setDisabled(false)
            helpers.showPopupgenerico("blocked",context,contenuto)
          
            //ReactGA.pageview('/ko', response.error);
          }

        }catch(err){
            helpers.logToBackend("Credit card page try catch",{err:err.message,tentativo:tentativi})
            const contenuto = helpers.contenuto_popop_pagamento("generico")
          
            setDisabled(false)
            helpers.showPopupgenerico("blocked",context,contenuto)
        }
    }


    async function procedura3DS(res){
        console.log(res)
        setModule_3ds(res.payment_system)
        setProps_3ds(res)

    }



    



    const onCreditCardChange = (e) => {
  
      
      const value = e.target.value
      
      const type = getCreditCardType(value)
      changeCreditCardIcon(type)

      const numericInput = value.replace(/\D/g, '');
      const formattedInput = numericInput.replace(/(.{4})/g, '$1 ').trim();
      setNumber(formattedInput)

      if(value.length > 19 && !isValidCreditCard(value)){
        setError({...error,cardNumber:true})
      }else{
        setError({...error,cardNumber:false})
      }
      
      if(load){
        setLoad(false)
        //helpers.logToBackend("Inizio compilazione",{clickid:localStorage.getItem('trackerId')})
        // ReactGA.event({ category: 'User',action: 'Inizio compilazione cc'})
      }
    }


 

    const onCreditCardExpiryChange = (e) => {

      
      let value = e.target.value.replace(/[^\d]/g, '');

      if (value.length > 2) {
        value = value.slice(0, 2) + '/' + value.slice(2, 4);
      }

      if (value.length > 5) {
       
      }

      setExpiry(value);

      if (value.length === 5 ) {   
             
        helpers.isValidDate(value) ? setError({...error,expiry:false}) : setError({...error,expiry:true})
      }else{
        setError({...error,expiry:false})
      }
    }

    const onCVVChange = (e) => {

      const input = e.target.value;
      const numericInput = input.replace(/\D/g, '');
      if (input.length === 3 ) {
        setError({...error,cvc:false})
      }
      setCvc(numericInput);
    }
 

    useEffect(() => {  
      console.log("CREDIT CARD FORM MOUNTED",props)

      if(!context.rateplanScelto.prezzo){
        navigate('/vip_plan/cred')
      }
    },[]);

    return(<div className="formPagamento">
        
               

                  {!props.form_invisibile && (
                    <form onSubmit={handleSubmit(onSubmit)} id="payment-form">
                        <div className="purchase-group">
                         
                          <div className="inputContainer">
                          <i className={icon}></i>
                            <input 
                              placeholder={placeHolderNumeroCarta} 
                              name="cardNumber"
                              onChange={onCreditCardChange}
                              className={error.cardNumber ? ("input-purchase errorCardInput") : ("input-purchase")}
                              disabled={disabled}
                              inputMode="numeric"
                              value={number}
                              maxLength="19"
                            /> 
                          </div>

                          <div className="purchase_info_container">
                        
                            <div className="col-6">
                              <input 
                                placeholder="MM/YY"
                                name="expiry"
                                onChange={onCreditCardExpiryChange}
                                className={error.expiry ? ("input-purchase errorCardInput") : ("input-purchase")}
                                value={expiry}
                                inputMode="numeric"
                                disabled={disabled}
                              />
                            </div>
                            <div className="col-6">

                              <input
                                placeholder="CVV"
                                maxLength="3"
                                name="cardSecurityCode"
                                style={{ WebkitTextSecurity: 'disc' }}
                                autoComplete="off"
                                onChange={onCVVChange}
  
                                inputMode="numeric"
                                className={error.cvc ? ("input-purchase errorCardInput") : ("input-purchase")}
                                disabled={disabled}
                                value={cvc}
                              />
                            </div>
                          </div>

                          <div className="purchase_info_container">
                            <div className="col-6">
                                
                                <input
                                    type="text"
                                    name="firstName"
                                    className={error.firstName ? ("input-purchase errorCardInput") : ("input-purchase")}
                                    placeholder={placeHolderNome}
                                    disabled={disabled}
                                    {... register('firstName')}
                                />
                            </div>
                            <div className="col-6">
                            
                                <input
                                    type="text"
                                    name="lastName"
                                    className={error.lastName ? ("input-purchase errorCardInput") : ("input-purchase")}
                                    placeholder={placeHolderCognome}
                                    disabled={disabled}
                                    {... register('lastName')}
                                />
                            </div>
                          </div>
                        </div>
                        
                        <div className="loghettiPayment">
                          <img src="/img/loghi_pagamento.png"></img>
                        </div>
                        
                        <div className="form-actions">
                            <button className="btn btn-block pay" disabled={disabled} ><Spinner/></button>
                            {context.fluxId === "0000" && 
                              (<p className="disclaimer">{Lang( {"w": "disclaimer_fluxid0000","page": "creditCardForm",placeholders:{ terms:config.servizi[window.location.hostname].legal_link.termini,privacy: config.servizi[window.location.hostname].legal_link.privacy }} )}</p>)                              
                            }
                            {context.fluxId !== "0000" &&  ( 
                              context.flusso.verificaEta ? 
                                (<p className="disclaimer">{Lang( {"w": "disclaimer_verifica_eta","page": "creditCardForm"} )}</p>)                              
                                :
                                (<p className="disclaimer">{Lang( {"w": "disclaimer","page": "creditCardForm"} )}</p>)  
                              )
                            }
                            <p className="descriptor">{Lang( {"w": "descriptor","page": "creditCardForm","placeholders": {descriptor:config.servizi[window.location.hostname].descriptor} } ) } </p>

                            {context.flusso.crossSelling && (
                              <div className="crossSellingInfo">
                                <p className="crossSelling__disclaimer" dangerouslySetInnerHTML={{ __html: Lang({ "w": "disclaimer_opale", "page": "creditCardForm", "var": true }) }} />
                                <label className="crossSelling__label">
                                  <input
                                    type="checkbox"
                                    className="crossSelling__checkbox"
                                    checked={!crossSellingAccepted}
                                    onChange={(e) => setCrossSellingAccepted(!e.target.checked)}
                                  />
                                  <span>Al momento non sono interessato/a.</span>
                                </label>
                              </div>
                            )}
                        </div>
                    </form>

                    
                  )}

                    
                {module3ds == "adyen" && (<><Module3ds_adyen {...props_3ds}/></>)}
                {module3ds == "trustpay" && (<><Module3ds_trpay {...props_3ds}/></>)}
                {module3ds == "maxpay" && (<><Module3ds_maxpay {...props_3ds}/></>)}
                {module3ds == "shift4" && (<><Module3ds_shift4 {...props_3ds}/></>)}
   
          </div>
                )

}